var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"analysis-container"},[_c('h2',[_vm._v(_vm._s(_vm.translate("detailed_analysis")))]),_c('div',{staticClass:"detail-fan-title"},[_vm._v(_vm._s(_vm.getActiveFun.type)+"  "+_vm._s(_vm.getActiveFun.model))]),_c('main',[_c('graphs-analysis-aside'),_c('analysis-graphs'),_c('div',{staticClass:"empty-aside"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }